import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCheckmarkCircleBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCheckmarkCircleBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 7H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M7 5a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm9 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0 2a7 7 0 1 0 0-14 7 7 0 0 0 0 14m3.048-7.702a1 1 0 0 0-1.414-1.414l-2.445 2.444-.883-.883a1 1 0 0 0-1.415 1.414l1.591 1.59.707.708.707-.707z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCheckmarkCircleBox32);
